import { useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from './use-auth';

interface UpdateProfileData {
  full_name?: string;
  avatar_url?: string | null;
}

export function useUserProfile() {
  const { user } = useAuth();
  const queryClient = useQueryClient();

  const updateProfile = useMutation({
    mutationFn: async (data: UpdateProfileData) => {
      if (!user?.id) {
        throw new Error('Usuário não autenticado');
      }

      const { error } = await supabase
        .from('profiles')
        .update(data)
        .eq('id', user.id);

      if (error) {
        throw error;
      }
    },
    onSuccess: () => {
      // Invalidate auth context to refetch profile data
      queryClient.invalidateQueries({ queryKey: ['auth'] });
    },
  });

  return {
    updateProfile: updateProfile.mutateAsync,
    isLoading: updateProfile.isPending,
    error: updateProfile.error,
  };
}